"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _taggedTemplateLiteral = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var tss_react_1 = require("tss-react");
var useStyles = (0, mui_1.makeStyles)()({
  dots: {
    '&::after': {
      display: 'inline-block',
      content: '""',
      width: '1em',
      textAlign: 'left',
      animation: "".concat((0, tss_react_1.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      0% {\n        content: '...';\n      }\n      25% {\n          content: '';\n      }\n      50% {\n        content: '.';\n      }\n      75% {\n        content: '..';\n      }\n      "]))), " 1.2s infinite ease-in-out")
    }
  }
});
function LoadingEllipses(_ref) {
  var message = _ref.message,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body2' : _ref$variant,
    rest = _objectWithoutProperties(_ref, ["message", "variant"]);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return react_1.default.createElement(material_1.Typography, _objectSpread({
    className: classes.dots
  }, rest, {
    variant: variant
  }), "".concat(message || 'Loading'));
}
exports.default = LoadingEllipses;